module.exports = __webpack_public_path__ + "img/top-temp.72cdabb4.png";